import React from 'react'
import PropTypes from 'prop-types'

import AbsoluteSubtext from '@atoms/AbsoluteSubtext'
import Button from '@atoms/Button'
import CTA from '@molecules/CTA'
import TextBox from '@atoms/TextBox'
import SignUpButton from '../../molecules/SignUpButton'

const SignupCTA = ({ active, bgColor, header, text }) => {
  return (
    <CTA bgColor={bgColor} center>
      <TextBox title="Get started" center>
        <h2>{header ? header : `It's easy to get started`}</h2>
        {text ? (
          text
        ) : (
          <p>
            See what you can accomplish with Ideolo boards.
            <br />
            Explore our features with a free plan.
          </p>
        )}
        <SignUpButton
          noCreditCard
          text={header ? 'Sign Up for free' : 'Sign Up'}
        />
      </TextBox>
    </CTA>
  )
}

SignupCTA.propTypes = {
  bgColor: PropTypes.string,
  active: PropTypes.bool,
}

SignupCTA.defaultProps = {
  bgColor: 'white',
  active: false,
}

export default SignupCTA
